import { PwaInstallBanner } from "@/components/PwaInstallBanner";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import NotFound from "@/pages/NotFound";
import { SignIn, SignUp } from "@clerk/clerk-react";
import { Route, Switch } from "wouter";
import ErrorBoundary from "./components/ErrorBoundary";
import { ThemeProvider } from "./contexts/ThemeContext";
import Home from "./pages/Home";
import Admin from "./pages/Admin";
import SongAudit from "./pages/SongAudit";
import Contact from "./pages/Contact";
import Advertise from "./pages/Advertise";
import Schedule from "./pages/Schedule";
import SubmitMusic from "./pages/SubmitMusic";

function Router() {
  return (
    <Switch>
      <Route path="/sign-in">
        <div className="flex min-h-screen items-center justify-center bg-background p-4">
          <SignIn
            routing="path"
            path="/sign-in"
            signUpUrl="/sign-up"
            afterSignInUrl="/"
            afterSignUpUrl="/"
          />
        </div>
      </Route>
      <Route path="/sign-up">
        <div className="flex min-h-screen items-center justify-center bg-background p-4">
          <SignUp
            routing="path"
            path="/sign-up"
            signInUrl="/sign-in"
            afterSignInUrl="/"
            afterSignUpUrl="/"
          />
        </div>
      </Route>
      <Route path={"/"} component={Home} />
      <Route path={"/admin"} component={Admin} />
      <Route path={"/admin/songs"} component={SongAudit} />
      <Route path={"/contact"} component={Contact} />
      <Route path={"/advertise"} component={Advertise} />
      <Route path={"/submit-music"} component={SubmitMusic} />
      <Route path={"/schedule"} component={Schedule} />
      <Route path={"/404"} component={NotFound} />
      <Route component={NotFound} />
    </Switch>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <ThemeProvider defaultTheme="dark">
        <TooltipProvider>
          <Toaster />
          <Router />
          <PwaInstallBanner />
        </TooltipProvider>
      </ThemeProvider>
    </ErrorBoundary>
  );
}

export default App;
